import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ConfigContext from '../../../contexts/ConfigContext';

import sidebarStyles from '../../../../stylesheets/public/layouts/SidebarLayout.module.postcss';
import styles from './TruckSidebar.module.postcss';

function TruckSidebar({ truckName }) {
  const { city_name, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <div className={sidebarStyles.Sidebar}>
      <div className={sidebarStyles.Sidebar_item}>
        <div className={sidebarStyles.Sidebar_header}>
          <h3 className='u-phosphate u-mb0'>Book this food {vehicleType}</h3>
        </div>
        <div className={sidebarStyles.Sidebar_padding}>
          <p>Tell us about your event to request a quote from {truckName} and compare it with quotes from other {city_name} food {vehicleType}s.</p>

          <Link to='/catering/requests/new' className='Button u-mb1 u-w100'>
            {truckName ? `Get a quote from ${truckName}` : 'Get catering quotes'}
          </Link>

          <p className='u-textCenter'>Requesting quotes is free.</p>
        </div>
      </div>

      <div className={sidebarStyles.Sidebar_item + ' ' + sidebarStyles.Sidebar_padding}>
        <h3 className='u-phosphate u-mb1'>Why book with us?</h3>
        <div className={styles.TruckSidebar_list}>
          <div>
            <div><span className='icon icon-approved' /></div>
            <div>Compare options before you book.</div>
          </div>
          <div>
            <div><span className='icon icon-approved' /></div>
            <div>Message {vehicleType}s directly.</div>
          </div>
          <div>
            <div><span className='icon icon-approved' /></div>
            <div>See the full price, including fees, before you book.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

TruckSidebar.propTypes = {
  truckName: PropTypes.string,
};

export default TruckSidebar;
